import React from 'react'

import { Card } from '@percent/lemonade'
import style from './ErrorView.module.scss'
import { ErrorViewProps } from './ErrorView.types'

// The wrapper sizes to the message, since Lemonade's Card is full width; a plain <p> keeps errorMessage's
// margin and colour, which Lemonade's Text would override.
export function ErrorView({ errorMessage }: ErrorViewProps) {
  return (
    <div className={style.errorContainer}>
      <div>
        <Card>
          <p className={style.errorMessage}>{errorMessage}</p>
        </Card>
      </div>
    </div>
  )
}
